export default function convertPriceResponse(response, dateProperty) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (dateProperty === void 0) { dateProperty = 'departureDate'; }
    var priceDictionary = {};
    var lowestFoundPrice;
    var highestFoundPrice;
    // @ts-ignore
    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.flights) {
        // @ts-ignore
        for (var _i = 0, _l = (_b = response.data) === null || _b === void 0 ? void 0 : _b.flights; _i < _l.length; _i++) {
            var item = _l[_i];
            if ((_c = item.prices) === null || _c === void 0 ? void 0 : _c.totalPrices[0]) {
                var dateKey = dateProperty === 'returnDate' && item.returnDate ? item.returnDate : item.departureDate;
                priceDictionary[new Date(dateKey).toLocaleDateString('en-CA')] = (_d = item.prices) === null || _d === void 0 ? void 0 : _d.totalPrices[0];
                if (!lowestFoundPrice || ((_e = item.prices) === null || _e === void 0 ? void 0 : _e.totalPrices[0].total) < lowestFoundPrice.total) {
                    lowestFoundPrice = (_f = item.prices) === null || _f === void 0 ? void 0 : _f.totalPrices[0];
                }
                if (!highestFoundPrice || ((_g = item.prices) === null || _g === void 0 ? void 0 : _g.totalPrices[0].total) > highestFoundPrice.total) {
                    highestFoundPrice = (_h = item.prices) === null || _h === void 0 ? void 0 : _h.totalPrices[0];
                }
            }
        }
    }
    // @ts-ignore
    var currencies = (_k = (_j = response === null || response === void 0 ? void 0 : response.dictionaries) === null || _j === void 0 ? void 0 : _j.dictionaries) === null || _k === void 0 ? void 0 : _k.currency;
    return {
        prices: priceDictionary,
        lowestFoundPrice: lowestFoundPrice,
        highestFoundPrice: highestFoundPrice,
        currencies: currencies,
    };
}
